import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { FOCUS_RING_OFFSET } from "../../lib/focus-ring";
import { cn } from "../../lib/utils";

type SliderProps = React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>;

// One thumb per value: the controlled value, else the default, else one thumb.
function thumbValues({ value, defaultValue }: SliderProps): number[] {
  if (value) return value;

  return defaultValue ?? [0];
}

export const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-secondary">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>
    {thumbValues(props).map((_, i) => (
      <SliderPrimitive.Thumb
        key={i}
        className={cn(
          "block size-4 rounded-full border border-primary bg-card shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
          FOCUS_RING_OFFSET
        )}
      />
    ))}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;
